module.exports = __webpack_public_path__ + "static/media/download.cb9ec097.svg";